import ApiService from 'services/ApiService/ApiService';
import ConfigurationService, { ConfigurationKeys } from 'services/ConfigurationService';
import { resolveURLPath } from 'utils/urlHelpers';


class ChatBotsService {
  getBotsInfo = async({ token }) => {
    const baseUrl = ConfigurationService.get(ConfigurationKeys.CHAT_BOTS_URL);
    const endPoint = 'v1/chat-bots';

    const url = new URL(baseUrl);
    url.pathname = resolveURLPath(url.pathname, endPoint);

    const params = { 'Authorization': `Bearer ${token}` };

    let data = undefined;
    let error = undefined;
    try {
      const response = await ApiService.get(url, { headers: params });

      data = response?.data;
    } catch (err) {
      error = err;
    }

    return { data, error };
  };

  getWelcomeBotInfoForViewer = async({ token, userId }) => {
    const baseUrl = ConfigurationService.get(ConfigurationKeys.CHAT_BOTS_URL);
    const endPoint = `v1/users/${userId}/chat-bots`;

    const url = new URL(baseUrl);
    url.pathname = resolveURLPath(url.pathname, endPoint);

    const params = { 'Authorization': `Bearer ${token}` };

    let data = undefined;
    let error = undefined;
    try {
      const response = await ApiService.get(url, { headers: params });

      data = response?.data;
    } catch (err) {
      error = err;
    }

    return { data, error };
  };

  saveBot = async(botDetails) => {
    const { botType, id, enabled, options, token } = botDetails;

    const baseUrl = ConfigurationService.get(ConfigurationKeys.CHAT_BOTS_URL);
    const url = new URL(baseUrl);

    const botAlreadyCreated = Boolean(id);
    const endPoint = botAlreadyCreated ? `v1/chat-bots/${id}` : 'v1/chat-bots';
    url.pathname = resolveURLPath(url.pathname, endPoint);

    const params = { 'Authorization': `Bearer ${token}` };
    const payload = {
      botType,
      details: options,
      enabled,
    };

    let data = undefined;
    let error = undefined;
    try {
      let response = undefined;
      if (botAlreadyCreated) {
        response = await ApiService.patch((url), { headers: params, data: JSON.stringify(payload) });
      } else {
        response = await ApiService.post((url), { headers: params, data: JSON.stringify(payload) });
      }

      data = response?.data;
    } catch (err) {
      error = err;
    }

    return { data, error };
  };
}

export default new ChatBotsService();
